import { MergeCellsOutlined } from "@ant-design/icons";

import "./NodeHeader.scss";
import { ButtonDelete } from "../../../ButtonDelete";
import { handleDeleteInputNode } from "../../../utils/removeDataNode";

const NodeHeader = ({ title, setNodes, setEdges, nodeId, ...res }) => {
  return (
    <div className="entry-header">
      <div className="entry-icon">
        <MergeCellsOutlined />
      </div>
      <div className="entry-title-wrapper">
        <span className="entry-title">{title}</span>
      </div>
      <ButtonDelete
        setNodes={setNodes}
        setEdges={setEdges}
        nodeId={nodeId}
        handleDelete={() => handleDeleteInputNode(res.updateIntent)}
      />
    </div>
  );
};

export default NodeHeader;
